module.exports = __webpack_public_path__ + "img/destination.3bbcbd79.svg";